import React from 'react';
import Layout from '../components/Layout';
import Section from '../components/Section';
import Head from '../components/head';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import { FranchiseeProvider } from '../context/Franchisee';

interface Careers {
}

const Careers: React.FC<Careers> = () => (
  <FranchiseeProvider>
    <Layout alternateFooter>
      <Head
        slug='careers'
        title='House Cleaning Jobs - Two Maids '
        description='At Two Maids, we believe in our house cleaners. Join us & be part of a team that values your well-being as we deliver exceptional service together.'
      />
      <OpenGraphTitle title='House Cleaning Jobs - Two Maids ' />
      <OpenGraphDescription>
        At Two Maids, we believe in our house cleaners. Join us & be part of a team that values your well-being as we deliver exceptional service together.
      </OpenGraphDescription>
      <div className="careers-jumbotron mb-5">
        <Section>
          <h1>Join a team that is Powered by Caring</h1>
          <p>
            At Two Maids, we're more than a cleaning company, we're a people-first team that changes lives one home at a time. Whether you're looking for flexibility, 
            growth, or purpose, your future will shine bright here.
          </p>
          <a href="https://two-maids-careers.careerplug.com/jobs?z=20559&d=25&n=&t=&locale=en-US#job_filters" target="_blank">APPLY NOW</a>
        </Section>
      </div>

      <Section>
        <div className='careers-why-section mb-5'>
          <div>
            <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761750948/careers_img_1_f5xxg0.webp" alt="We Care" />
          </div>

          <div>
            <h2>
              Why work at Two Maids?
            </h2>
            <p className='careers-why-body'>
              We believe people are our purpose. Every smile, every shine, and every extra effort shapes how customers experience our brand. That's why we put people 
              first - because when you succeed, so do we.
            </p>
            <h3>
              1. We care for each other:
            </h3>
            <p>
              Teamwork, support, and respect are the foundation of our culture.
            </p>

            <h3>
              2. We care for our customers:
            </h3>
            <p>
              Families depend on us to make their lives easier and their homes brighter.
            </p>

            <h3>
              3. We care for our work:
            </h3>
            <p>
              Pride in every detail is what sets us apart.
            </p>
          </div>
        </div>
        <p  className='careers-why-body mb-5'>
          At Two Maids, you'll find balance, flexibility, and a workplace that values the person behind the uniform.
        </p>
      </Section>


      <div className="careers-path-section">
        <Section>
            <h2>Career Paths & Growth Opportunities</h2>
            <h3>A job at Two Maids is often just the beginning.</h3>

            <div className='d-flex'>
              <div className='why-two-maids-video-container'>
                <div>
                  <h4>We offer:</h4>
                  <ul>
                    <li>
                      <strong>Room to Grow</strong> - From Professional House Cleaner to trainer, manager or even franchise owner, your path is yours to create.
                    </li>
                    <li>
                      <strong>Built-In Support</strong> - Onboarding, training, and periodic check-ins to ensure you feel confident from day one.
                    </li>
                    <li>
                      <strong>Flexibility</strong> - Choose schedules that work with your life, not against it.
                    </li>
                  </ul>
                  <p>
                    Whether you're here for a season or building a long-term career, your time at Two Maids will help you grow 
                    personally and professionally.
                  </p>
                </div>
                <div>
                  <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761753280/careers_img_2_tzoett.webp" alt="We Care" />
                </div>
              </div>
            </div>
        </Section>
      </div>

      <div className="careers-thrive-section">
        <Section>
          <h2>Who thrives here?</h2>
          <h3>Do you see any of these in yourself?</h3>
          <div className="careers-thrive-grid">
            <div>
              <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761769348/hubsite-reskin/TM_Self-Driven_icon.svg" alt="" />
                <h4>Independent & Self-Driven</h4>
                <p>
                  You're motivated, reliable, and love taking charge of your own success.
                </p>
            </div>

            <div>
              <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761769349/hubsite-reskin/TM_Team_Community_icon.svg" alt="" />
                <h4>Team-Oriented & Community-Minded</h4>
                <p>
                  You thrive on collaboration and shared goals.
                </p>
            </div>

            <div>
              <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761769348/hubsite-reskin/TM_Purpose_Driven__icon.svg" alt="" />
                <h4>Empathetic & Purpose-Driven</h4>
                <p>
                  You find meaning in caring for others, including supporting cancer patients through our Cleaning for a Reason partnership.
                </p>
            </div>

            <div>
              <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761769349/hubsite-reskin/TM_Seeking_Satisfaction__icon.svg" alt="" />
                <h4>Proud & Seeking Satisfaction</h4>
                <p>
                  You take pride in creating spotless homes and satisfied customers.
                </p>
            </div>
          </div>
          <h2>No matter your style, there's a place for you here.</h2>
        </Section>
      </div>

      <div className="careers-life-section-desktop">
        <Section>
          <h2>Life at Two Maids</h2>
          <h3>At Two Maids, every day is an opportunity to make a difference.</h3>

          <div>
            <p className='careers-our-promise'>Our Promise</p>
            <div className='careers-graphic-layout-desktop'>
              <div>
                <h4>WE OFFER:</h4>
                <ul>
                  <li>Support</li>
                  <li>Opportunity</li>
                  <li>Training</li>
                  <li>Direction</li>
                </ul>
              </div>
              <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761771708/hubsite-reskin/TogetherHeart.webp" alt="" />
              <div>
                <h4>YOU BRING:</h4>
                <ul>
                  <li>Consistency</li>
                  <li>Pride</li>
                  <li>Effort</li>
                  <li>Cooperation</li>
                </ul>
              </div>
            </div>

            <div className="careers-together-we">
              <h4>TOGETHER WE:</h4>
              <p>Build a successful culture and business that helps each other grow</p>
            </div>

          </div>
          <h2 className='text-center'>Here, your work matters - and so do you.</h2>
        </Section>
      </div>


      <div className="careers-work-life-section">
        <Section>

              <div className='d-flex'>

                <div className='careers-work-life-container'>

                  <div>
                    <h2>Work-Life Balance & Beyond</h2>

                    <p>
                      We know life doesn't stop when your shift ends. That's why we respect time off, encourage personal goals, and celebrate the people behind the uniforms
                    </p>

                    <p>
                      At Two Maids, you'll find more than a job - you'll find a team that wants you to succeed in life, wherever your dreams take you. When you leave Two Maids, 
                      we want you to say: "I'm better for having known them."
                    </p>

                  </div>

                  <div>
                    <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1761753429/careers_img_4_uelgm7.webp" alt="We Care" />
                  </div>

                </div>

              </div>
        </Section>
      </div>

      <div className="careers-link-section">
        <Section>
          <div className="careers-link-body">
            <div>
              <h2>Ready to Shine?</h2>
            </div>
            <a href="https://two-maids-careers.careerplug.com/jobs?z=20559&d=25&n=&t=&locale=en-US#job_filters" target="_blank">APPLY NOW</a>
          </div>
        </Section>
      </div>
    </Layout>
  </FranchiseeProvider>
);

export default Careers;
